module.exports = __webpack_public_path__ + "static/media/ModuleSelect_sm.70a0ff8e.mp4";